import { TrDatePipe } from "@tr/pipes"
import { keyBy } from "lodash"

export function generateTree<DataItem>(
  dataList: any[],
  runDataList: any[],
  parentIdKey = "parentId",
  idKey = "id",
  idMap: { [treeRowId: string]: DataItem } | null = null,
  parentId: string | null = null,
): DataItem[] {
  if (!idMap) {
    idMap = keyBy(dataList, item => item[idKey])
  }

  return dataList
    .filter(item => item[parentIdKey] === (parentId == null ? null || "" : parentId))
    .map<DataItem>(item => {
      const treeItem: any = Object.assign({}, item)

      treeItem.end = new TrDatePipe().transform(treeItem.end)
      treeItem.start = new TrDatePipe().transform(treeItem.start)

      let childrenFromParent = []
      if (item.type !== "run") {
        const linkedRuns = runDataList.filter(run => run.parentId === item[idKey])
        const matchedLinkedRuns = []
        if (linkedRuns.length > 0) {
          linkedRuns.map(linkedRun => {
            matchedLinkedRuns.push({
              type: "run",
              name: linkedRun.runTitle,
              end: linkedRun.dueDate,
              start: linkedRun.startTime,
              numberDays: linkedRun.completionDays,
              milestoneRow: -1,
              milestoneRefId: "",
              isDisabled: false,
              testPlanRefId: linkedRun.parentId,
              children: [],
              parentId: linkedRun.parentId,
            })
          })
        }

        childrenFromParent = Object.keys(idMap)
          .filter(id => idMap[id][parentIdKey] === item[idKey])
          .map(id => idMap[id])

        if (matchedLinkedRuns.length > 0) {
          childrenFromParent = [...matchedLinkedRuns, ...childrenFromParent]
        }
      }

      treeItem.children = generateTree(childrenFromParent, runDataList, parentIdKey, idKey, idMap, item[idKey])

      return treeItem
    })
}

export function generateTreeFromList<DataItem>(dataList: any[], parentIdKey: string = "parentId", idKey: string = "id"): DataItem[] {
  return generateTreeFromListRecurse<DataItem>(dataList, parentIdKey, idKey)
  // return sortBy(list, (item) => item.level + "")
}

export function generateTreeFromListRecurse<DataItem>(
  dataList: any[],
  parentIdKey: string = "parentId",
  idKey: string = "id",
  idMap: { [treeRowId: string]: any } | null = null,
  parentId: string | null = null,
  level = 1,
  createdList = [],
): DataItem[] {
  if (!idMap) {
    idMap = keyBy(dataList, item => item[idKey])
  }

  (dataList || [])
    .filter(item => {
      if (!item[parentIdKey] && !parentId) {
        return true
      }

      return item[parentIdKey] === parentId
    })
    .forEach(item => {
      const treeItem: any = Object.assign({}, item)
      treeItem.level = level
      createdList.push(treeItem)

      const childrenFromParent = Object.keys(idMap)
        .filter(id => idMap[id][parentIdKey] === item[idKey])
        .map(id => idMap[id])

      if (childrenFromParent.length === 0) {
        return
      }
      createdList = generateTreeFromListRecurse(childrenFromParent, parentIdKey, idKey, idMap, item[idKey], level + 1, createdList)
    })

  return createdList
}
